import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/articles/cssbuy-sheet-complete-guide/page";
import SneakerGuide from "@/pages/articles/cssbuy-sneaker-guide/page";
import KakobuyVsCssbuy from "@/pages/articles/kakobuy-vs-cssbuy/page";
import SuperbuyGuide from "@/pages/articles/superbuy-beginner-guide/page";
import OopbuyQcGuide from "@/pages/articles/oopbuy-qc-guide/page";
import ShippingGuide from "@/pages/articles/shipping-optimization-guide/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/articles/cssbuy-sheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/articles/cssbuy-sneaker-guide",
    element: <SneakerGuide />,
  },
  {
    path: "/articles/kakobuy-vs-cssbuy",
    element: <KakobuyVsCssbuy />,
  },
  {
    path: "/articles/superbuy-beginner-guide",
    element: <SuperbuyGuide />,
  },
  {
    path: "/articles/oopbuy-qc-guide",
    element: <OopbuyQcGuide />,
  },
  {
    path: "/articles/shipping-optimization-guide",
    element: <ShippingGuide />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;